var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPersonalLetters = function SvgPersonalLetters(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 33 46"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#F28230",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5,
    d: "M31.755 9.439h-7.439V2zM5.72 7.579h1.859M11.298 7.579h9.299M5.72 13.158h1.859M11.298 13.158h16.738M5.72 18.737h1.859M11.298 18.737h16.738M5.72 24.316h1.859M11.298 24.316h16.738M17.807 34.08h10.228M9.904 38.264a4.184 4.184 0 1 0 0-8.369 4.184 4.184 0 0 0 0 8.369"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F28230",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5,
    d: "M31.755 9.439v34.404H2V2h22.316"
  })));
};
export default SvgPersonalLetters;